import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    gap: 40,

    [theme.breakpoints.up('laptop')]: {
      paddingTop: SPACES.l,
    },
  },

  verifyModal: {
    '&&': {
      padding: SPACES.xxl,
      paddingTop: SPACES.xxxxxl,
      minWidth: '334px',

      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xxxxxl,
    },
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxl,
  },
  scanHide: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '78px',
    backgroundColor: theme.palette.background.default,
    zIndex: 202,
  },
}))
